import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';

export const equipmentRequestsDetailService = {
  async getRequest(id: string, userId: string) {
    const { data: request, error: reqError } = await supabase
      .from('equipment_requests')
      .select(`
        *,
        project:projects(id, name),
        requester:user_profiles!requester_id(id, full_name, avatar_path),
        approver:user_profiles!approved_by(id, full_name)
      `)
      .eq('id', id)
      .single();

    if (reqError) throw reqError;

    const { data: items, error: itemsError } = await supabase
      .from('equipment_request_items')
      .select(`
        *,
        equipment_type:categories(id, name),
        equipment:equipment_items(id, name, code)
      `)
      .eq('request_id', id);

    if (itemsError) throw itemsError;

    return { ...request, items };
  },

  async approveRequest(id: string, userId: string, companyId: string) {
    await permissionEngine.assert(userId, 'equipment.requests.approve', { companyId });
    
    const { error } = await supabase
      .from('equipment_requests')
      .update({
        status_code: 'approved',
        approved_by: userId,
        approved_at: new Date().toISOString(),
      })
      .eq('id', id);

    if (error) throw error;
  }
};
